module.exports = __webpack_public_path__ + "static/img/5.2bd1c5b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/5.png
// module id = 5wJR
// module chunks = 0